<template>
    <div>
      <p>Redirecting...</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RedirectComponent',
    mounted() {
      this.redirectToExternalUrl();
    },
    methods: {
      redirectToExternalUrl() {
        const userId = localStorage.getItem('auth_code');
        const clientId = localStorage.getItem('client_id');
        const access_token = localStorage.getItem('access_token');
        const ws_session = localStorage.getItem("ws_token");

        if (userId) {
          window.location.href = `https://beta.1lyoptions.com/loginsuccess?s=ok&code=200&client_id=${clientId}&user_id=${userId}&broker=aliceblue&access_token=${access_token}&ws_token=${ws_session}`;
        } else {
          // Handle the case when userId is not found in localStorage
          console.error('userId not found in localStorage');
        }
      }
    }
  };
  </script>
  